import { Component } from '@angular/core';

/**
 * Renders the interface for composing new mails
 */
@Component({
  templateUrl: './compose.component.html',
  styleUrls: ['./compose.component.scss'],
})
export class ComposeComponent {
  nyanCat = require('../../../../assets/demo/Nyan_cat_250px_frame.jpg');
}



// WEBPACK FOOTER //
// ./src/app/mailbox/compose/compose.component.ts